import { Platform } from 'react-native';
import { MarisaAppUtils } from './MarisaAppUtils';

export const MARISA_CONSORTIUM_APP_LINK =
  'https://consorciomarisa.com.br/?utm_source=app-marisa&utm_medium=banner-hub&utm_campaign=app-hub&utm_content=base-app';
export const MARISA_CONSORTIUM_WEB_LINK =
  'https://consorciomarisa.com.br/?utm_source=site-marisa&utm_medium=banner-site-hub&utm_campaign=hub&utm_content=site-marisa';
export const MARISA_CONSORTIUM_TOTEM_LINK =
  'https://consorciomarisa.com.br/?utm_source=totem&utm_medium=totem-loja&utm_campaign=totem-loja&utm_content=lojas-marisa';
export const ASSURANT_WEBSITE = 'https://www.assurant.com.br/';

export const getFormattedLinkToBrowser = (
  url: string,
  applyToAll: boolean = false
): string => {
  if (applyToAll)
    return `http://docs.google.com/gview?embedded=true&url=${url}`;

  if (Platform.OS === 'android') {
    return `http://docs.google.com/gview?embedded=true&url=${url}`;
  }

  return url;
};

//TERMS
export const BAG_PROTECTION_ACCESSION_TERMS_LINK = getFormattedLinkToBrowser(
  'https://psffiles.blob.core.windows.net/psfcontratos/termos/seguros/assurant/bolsa-protegida/termo-adesao.pdf'
);
export const INCOME_PROTECTION_ACCESSION_TERMS_LINK = getFormattedLinkToBrowser(
  'https://psffiles.blob.core.windows.net/psfcontratos/termos/seguros/assurant/protecao-perda-de-renda/termo-adesao.pdf'
);
export const MARISA_TAKES_CARE_ACCESSION_TERMS_LINK = getFormattedLinkToBrowser(
  'https://psffiles.blob.core.windows.net/psfcontratos/termos/seguros/redemais/marisa-cuida/termo-adesao.pdf'
);
////////////////////////////////

export const openCredsystem = () => {
  const url = Platform.select({
    ios: 'https://apps.apple.com/br/app/cart%C3%A3o-marisa/id6469040249',
    web: 'https://www.portaldocartao.com.br/',
    default:
      'https://play.google.com/store/apps/details?id=br.com.portaldocartao.cartaomarisa',
  });
  MarisaAppUtils.openUrl(url);
};
